import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

function Layout() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1, padding: '24px', marginLeft: '220px' }}>
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;